import {filamentConfig,filamentColours} from './il-filament-palette-c1.js';
const _i18n=(()=>{try{const s=document.getElementById('il-i18n');return s?JSON.parse(s.textContent):{};}catch{return {};}})();
const t=(key,p={})=>{const v=_i18n[key]??key;return Object.entries(p).reduce((s,[k,val])=>s.replace('{'+k+'}',val),String(v));};
// Three views of one merged sign. All URLs come from Liquid's versioned asset_url.
const initialized = new WeakSet();
function bootstrap(scope) {
  const root=scope.querySelector('[data-union-preview]');
  const configNode=scope.querySelector('[data-union-config]');
  if(root&&configNode&&!initialized.has(root)){
    initialized.add(root);initialize(root,JSON.parse(configNode.textContent));
  }
}
bootstrap(document);
document.addEventListener('shopify:section:load',event=>bootstrap(event.target));

function initialize(root, cfg) {
  filamentConfig(cfg);
  const phoneRendering=matchMedia('(pointer:coarse)').matches;
  // Phones draw at the screen's own pixel density (at least 2x), within the
  // renderer's 1.5-million-pixel / 1600-pixel-width caps, for sharp edges (the
  // owner, 28 September). This was the opt-in preview_quality=high, timed on a
  // real Android phone without a slower finish (docs/real-phone-preview-benchmark.md).
  // preview_quality=standard restores the earlier phone budget for comparisons.
  const quality=new URLSearchParams(location.search).get('preview_quality');
  const fullQuality=quality==='high'||(phoneRendering&&quality!=='standard');
  let editDeadline=0;
  let preparer;
  const layers=cfg.layers||[12,0,1],depth=Number(layers.reduce((sum,n)=>sum+n,0).toFixed(1));
  const compactFamily=cfg.keychain||cfg.magnet;
  const metalSurface=!!cfg.magnet;
  const compactWidth=cfg.magnet?(cfg.maxWidthMM||80):100;
  const objectLabel=cfg.magnet?'magnet':cfg.ornament?'ornament':compactFamily?'keychain':'sign';
  // Both ornament cameras see the same tree behind the hanging piece.
  if(cfg.ornament){
    root.classList.add('ilup--ornament');
    const tree=getComputedStyle(root.querySelector('.ilup__viewport')).backgroundImage.match(/url\("?([^")]+)"?\)/)?.[1];
    if(tree){const picture=new Image();picture.fetchPriority='low';picture.src=tree;}
  }
  // Measurements are written with the page language's decimal separator.
  const language=document.documentElement.lang||'en';
  const measure=mm=>model.dimensionText(mm,units,language);
  const depthText=()=>units==='in'?measure(depth):new Intl.NumberFormat(language,{maximumFractionDigits:1}).format(depth)+' mm';
  const form = document.getElementById('il-buy');
  const input = document.querySelector('[data-text-input][form="il-buy"]');
  const collectionName=new URLSearchParams(location.search).get('preview_name')?.normalize('NFC');
  if(input&&!input.value&&collectionName&&(cfg.accentedLetters?/^[A-Za-zÀ-ÖØ-öø-ÿ]{1,12}$/:/^[A-Za-z]{1,12}$/).test(collectionName)){
    input.value=collectionName;
    input.dispatchEvent(new Event('input',{bubbles:true}));
  }
  // Product decisions live with the purchase form; the renderer remains in its own root.
  const productScope = root.closest('.fold') || root;
  const query = selector => productScope.querySelector(selector);
  const lightningSelect=query('[data-lightning-position]'),lightningProperty=query('[data-lightning-property]');
  // The bolt's place is read from a label of our own; the select lies over it,
  // transparent (il-union-preview.css). The name with the bolt, hidden beside the
  // label, keeps the control as wide as its widest option.
  const lightningNow=query('[data-lightning-now]'),lightningWidest=query('[data-lightning-widest]');
  function lightningShown(){if(lightningNow)lightningNow.textContent=lightningSelect.selectedOptions[0]?.textContent||'';}
  // The cart's "View design" link brings the customer's own choices back with the
  // name: where the bolt sits (preview_bolt) and the leveling foot (preview_foot).
  const chosen=new URLSearchParams(location.search);
  let lightningChoice=/^\d{1,2}$/.test(chosen.get('preview_bolt')||'')?chosen.get('preview_bolt'):'auto';
  function lightningOptions(text){
    if(!lightningSelect)return;
    const selected=lightningChoice==='auto'?'auto':String(Math.min(Number(lightningChoice),text.length));
    lightningSelect.replaceChildren(new Option(t('preview.lightning_auto'),'auto'),...Array.from({length:text.length+1},(_,i)=>new Option(text.slice(0,i).toUpperCase()+'⚡'+text.slice(i).toUpperCase(),String(i))));
    lightningSelect.value=selected;lightningChoice=selected;
    if(lightningWidest)lightningWidest.textContent=lightningSelect.options[text.length+1].textContent;
    lightningShown();
  }
  function lightningProperties(job){
    if(!lightningProperty)return;
    lightningProperty.disabled=job.example;
    lightningProperty.value=job.lightning.layout;
  }
  const gallery = query('[data-preview-gallery]'), size = query('[data-preview-size]');
  const status = query('[data-preview-status]'), fallback = query('[data-preview-fallback]');
  const accentNote = query('[data-preview-accent-note]');
  const retry = query('[data-preview-retry]');
  const keychainSpec=query('[data-keychain-spec],[data-magnet-spec]'),keychainReview=query('[data-keychain-review],[data-magnet-review]');
  const signSpec=query('[data-sign-spec]'),signReview=query('[data-sign-review]');
  const supportCard=query('[data-preview-support]'),supportToggle=query('[data-support-toggle]');
  const supportProperty=query('[data-support-property]'),supportPlacement=query('[data-support-placement]'),supportSpec=query('[data-support-spec]');
  const step = input?.closest('[data-step="text"]');
  const lightningControl=lightningSelect?.closest('.ilup__lightning');
  if(lightningControl&&step)step.querySelector('.inp').after(lightningControl);

  // One renderer (one graphics context) draws the three views; each view's canvas
  // shows a copy (viewTargets). The program compiles and the geometry uploads once:
  // browsers that cannot compile in the background (Firefox) froze once per view.
  let model, Renderer, manifest, images, worker, renderer = null, rendererLost = null, viewTargets = [];
  let active = root.dataset.active, units = 'cm', revision = 0, busy = false, wanted = false;
  let timer, drawFrame, workerTimer, currentJob, result, loading = false, destroyed = false;
  let generation = 0, loadController, graphics = null, graphicsReady = false;
  let recoveryAttempts = 0, recoveryTimer;
  // flat: il-flat-picture.js where the browser has no WebGL 2; geometry: the last name's fields.
  let flat = null, geometry = null;
  function show(data, bounds) { geometry = {data, bounds}; renderer?.update(data, bounds); }
  // One view, seen from the front (the top view; a magnet's "Front"): the others need 3D.
  function showFlat() {
    root.dataset.flat = '';
    active = 'top'; root.dataset.active = active;
    views.forEach(card => { const selected = card.dataset.previewView === active; card.classList.toggle('is-active', selected); card.setAttribute('aria-pressed', String(selected)); });
  }
  const flatColours = colour => ({base: colour.base, face: colour.face, mid: cfg.colours.mid, midAccent: cfg.colours.midAccent, cap: cfg.colours.cap});
  function drawFlatView(colour) {
    const view = views.find(v => v.dataset.previewView === active) || views[0];
    const target = viewTargets.find(t => t.view === view);
    if (!target || !geometry || !result) return;
    const {canvas} = target, w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    const ratio = Math.min(Math.max(2, devicePixelRatio || 1), Math.sqrt(1500000 / (w * h)));
    const frame = flat.drawFlat(canvas, geometry.data, geometry.bounds, flatColours(colour), {width: w * ratio, height: h * ratio, cssWidth: w, layers, hardware: !!cfg.keychain, outline: result.outline});
    view.dataset.renderRevision = String(revision);
    annotations(view, frame);
  }
  let supportData, supportChoice=chosen.get('preview_foot')==='1'?true:chosen.get('preview_foot')==='0'?false:null, highlightUntil=0, highlightTimer;
  const views = [...root.querySelectorAll('[data-preview-view]')];

  function supportProperties() {
    if(!supportProperty)return;
    const eligible=!!supportData?.eligible,on=eligible&&supportToggle.checked;
    supportProperty.disabled=!eligible;supportProperty.value=on?'Yes':'No';
    supportPlacement.disabled=!on;supportSpec.disabled=!on;
    supportPlacement.value=on?supportData.placement:'';
    supportSpec.value=on?JSON.stringify(supportData.spec):'';
    const review=query('[data-support-review]');
    review.disabled=!supportData?.needsReview;
    review.value=supportData?.needsReview?'Automatic leveling foot unavailable; check standing balance and attachment before production.':'';
  }
  function describeFoot(foot,text) {
    const index=foot.glyphIndex,letter=text[index].toUpperCase();
    if(letter==='⚡')return t('foot.lightning');
    return text.length===1?t('foot.single',{letter}):index===0?t('foot.first',{letter}):index===text.length-1?t('foot.final',{letter}):t('foot.numbered',{index:index+1,letter});
  }
  // Where the foot goes, or both feet from left to right.
  function footPlace(analysis,text) {
    const feet=[analysis.foot,analysis.secondFoot].filter(Boolean).sort((a,b)=>a.centreX-b.centreX);
    return feet.length===2?t('foot.pair',{first:describeFoot(feet[0],text),second:describeFoot(feet[1],text)}):describeFoot(feet[0],text);
  }

  function colours() {
    const values = {...cfg.colours};
    if(cfg.fixedColours)return values;
    // A chip says which colour it chooses (data-opt-role, snippets/colour-role.liquid):
    // its option's name is translated, and a plain option button has no colour at all.
    form?.querySelectorAll('[data-opt-role][aria-pressed="true"]').forEach(button => {
      const rgb = getComputedStyle(button.querySelector('i') || button).backgroundColor.match(/[\d.]+/g);
      if (!rgb || rgb.length < 3) return;
      const hex = '#' + rgb.slice(0,3).map(n=>Math.round(Number(n)).toString(16).padStart(2,'0')).join('');
      if (button.dataset.optRole === 'face') values.face = hex;
      else if (button.dataset.optRole === 'base') values.base = hex;
    });
    // A family whose letters follow the base (faceonbase, Friends: white letters on
    // black, black on white) takes the letters' colour from the chosen base.
    const pair = String(cfg.faceOnBase || '').split(',').map(p => p.split('>')).find(([b]) => b && b.toLowerCase() === String(values.base).toLowerCase());
    if (pair) values.face = pair[1];
    return filamentColours(values);
  }

  function svgNode(tag, attributes, text) {
    const node = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.entries(attributes).forEach(([key,value]) => node.setAttribute(key,String(value)));
    if (text) node.textContent = text;
    return node;
  }
  function annotations(view, frame) {
    const svg = view.querySelector('svg');
    svg.replaceChildren();
    if (!result || !frame || view.dataset.previewView !== active) return;
    const canvas = view.querySelector('canvas'), w=canvas.clientWidth,h=canvas.clientHeight;
    svg.setAttribute('viewBox',`0 0 ${w} ${h}`);
    const o=result.outline;
    const points=[];
    for(const x of [o.minX,o.maxX])for(const y of [o.minY,o.maxY])for(const z of [0,depth])points.push(frame.project([x,y,z]));
    const left=Math.min(...points.map(p=>p.x)),right=Math.max(...points.map(p=>p.x));
    const top=Math.min(...points.map(p=>p.y)),bottom=Math.max(...points.map(p=>p.y));
    function line(x1,y1,x2,y2){svg.append(svgNode('line',{x1,y1,x2,y2}));}
    if(active==='low') {
      // Project the family's full depth beside the frontmost edge of the base.
      const a=frame.project([o.maxX,o.minY,0]),b=frame.project([o.maxX,o.minY,depth]);
      if(cfg.ornament){
        // On a hanging piece the edge projects sideways. Put the caliper below it.
        const y=Math.min(h-18,bottom+12);
        line(a.x,y,b.x,y);line(a.x,y-3,a.x,y+3);line(b.x,y-3,b.x,y+3);
        svg.append(svgNode('text',{x:(a.x+b.x)/2,y:y+15,'text-anchor':'middle'},depthText()));
      }else{
        const x=Math.min(w-42,right+16);
        line(x,a.y,x,b.y);line(x-3,a.y,x+3,a.y);line(x-3,b.y,x+3,b.y);
        svg.append(svgNode('text',{x,y:Math.max(a.y,b.y)+16,'text-anchor':'end'},depthText()));
      }
    }
    if(result.feet && performance.now()<highlightUntil)for(const foot of result.feet){
      const [x0,y0,x1,y1]=foot.bounds,points=[];
      for(const x of [x0,x1])for(const y of [y0,y1])for(const z of [0,foot.depthMM])points.push(frame.project([x,y,z]));
      const xs=points.map(p=>p.x),ys=points.map(p=>p.y);
      const left=Math.min(...xs),right=Math.max(...xs),top=Math.min(...ys),bottom=Math.max(...ys);
      svg.append(svgNode('rect',{x:left-6,y:top-6,width:right-left+12,height:bottom-top+12,rx:7,class:'ilup__foot-highlight'}));
    }
  }

  function draw() {
    cancelAnimationFrame(drawFrame);
    drawFrame=requestAnimationFrame(()=>{
      if(!result||root.dataset.state!=='ready'||destroyed)return;
      const colour=colours();
      // Persist the actual displayed palette, including variant changes that do
      // not require rebuilding geometry. Never retain an earlier colour choice.
      saveAppearance(colour);
      if(flat){try{drawFlatView(colour);}catch(error){fail(error);}return;}
      try {
        const drawRevision=revision;
        const queue=viewTargets.filter(target=>target.view.dataset.previewView===active);
        const next=()=>{
          if(drawRevision!==revision||root.dataset.state!=='ready'||destroyed||!renderer)return;
          const item=queue.shift();if(!item)return;
          const {view,canvas,context,elevation,upright,clear}=item;
          const isActive=view.dataset.previewView===active;
          // The shared renderer draws this view at the view's size; the view shows a copy.
          renderer.setView(elevation,upright,canvas.clientWidth,canvas.clientHeight,clear);
          const faceView=active==='top'||(!compactFamily&&active==='upright');
          const frame=renderer.draw(colour.base,colour.face,-35*Math.PI/180,isActive&&active==='low',faceView);
          if(frame){
            if(isActive)root.toggleAttribute('data-room-visible',!!frame.room);
            const source=renderer.canvas;
            if(canvas.width!==source.width||canvas.height!==source.height){canvas.width=source.width;canvas.height=source.height;}
            if(clear)context.clearRect(0,0,canvas.width,canvas.height);
            context.drawImage(source,0,0);
          }
          view.dataset.renderRevision=String(drawRevision);
          if(renderer.hardware&&view.dataset.previewView==='upright')view.querySelector('svg').replaceChildren();
          else annotations(view,frame);
          if(queue.length)drawFrame=requestAnimationFrame(()=>{try{next();}catch(error){fail(error);}});
        };
        next();
      } catch(error){fail(error);}
    });
  }

  function saveAppearance(colour=colours()) {
    for(const spec of [signSpec,keychainSpec])if(spec&&!spec.disabled&&spec.value){
      const value=JSON.parse(spec.value);
      value.colours=colour;value.fontSHA256=manifest?.font_sha256;
      value.constructionRevision=cfg.constructionRevision;
      spec.value=JSON.stringify(value);
    }
  }
  // The design as a collection card shows it (the same camera and light), drawn by
  // this page's renderer from the geometry it already holds: the cart line's
  // picture. il-cart.js keeps it for the line that the add creates.
  let cardModule;
  function cardReady(job){
    if(!job.example&&!cardModule&&cfg.cardRenderer)import(cfg.cardRenderer).then(module=>{cardModule=module;}).catch(()=>{});
  }
  function cardSnapshot(){
    // Flat: the same front view, on its own canvas at the card's size (300 x 225, twice over).
    if(flat){
      if(!result||!geometry||!currentJob||currentJob.example||root.dataset.state!=='ready')return null;
      try{
        const copy=document.createElement('canvas');
        flat.drawFlat(copy,geometry.data,geometry.bounds,flatColours(colours()),{width:600,height:450,layers,hardware:!!cfg.keychain,outline:result.outline,margin:.1});
        return new Promise(resolve=>copy.toBlob(blob=>{
          if(!blob){resolve(null);return;}
          const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=()=>resolve(null);reader.readAsDataURL(blob);
        },'image/webp',.9));
      }catch{return null;}
    }
    if(!renderer||!result||!cardModule||!currentJob||currentJob.example||root.dataset.state!=='ready')return null;
    const keep={options:renderer.options,elevation:renderer.elevation,upright:renderer.upright,viewSize:renderer.viewSize},colour=colours();
    try{
      const view=cardModule.cardView(cfg,model),o=result.outline;
      // Judas's texture is padded for its rotation: its card frames the silhouette.
      const framing=!compactFamily&&manifest?.family==='judas'?{minX:o.minX-4,minY:o.minY-4,width:o.maxX-o.minX+8,height:o.maxY-o.minY+8}:undefined;
      renderer.options={...keep.options,pixelRatio:2,mobileBudget:false,cameraFrame:view.cameraFrame,ceilingLight:view.ceilingLight,framing,roomSurface:false};
      renderer.setView(view.elevation,view.upright,cardModule.CARD_WIDTH,cardModule.CARD_HEIGHT);
      if(!renderer.draw(colour.base,colour.face,cardModule.CARD_LIGHT_ANGLE,false))return null;
      const copy=document.createElement('canvas');copy.width=renderer.canvas.width;copy.height=renderer.canvas.height;
      copy.getContext('2d').drawImage(renderer.canvas,0,0);
      return new Promise(resolve=>copy.toBlob(blob=>{
        if(!blob){resolve(null);return;}
        const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=()=>resolve(null);reader.readAsDataURL(blob);
      },'image/webp',.9));
    }catch{return null;}
    finally{Object.assign(renderer,keep);}
  }
  form?.addEventListener('submit',()=>{saveAppearance();form.ilCartSnapshot=cardSnapshot();},true);
  // The names picker (assets/il-names.js) keeps the same picture of each name it checks.
  root.ilCardSnapshot=()=>{saveAppearance();return cardSnapshot();};

  function dimensions() {
    if(!result||root.dataset.state==='invalid')return;
    const text=`${measure(result.widthMM)} ${t('preview.wide')} × ${measure(result.heightMM)} ${t('preview.high')} × ${compactFamily?depthText():measure(depth)} ${compactFamily?t('preview.thick'):t('preview.deep')}`;
    const sizeText = query('[data-preview-size-text]');
    const dimensions = [
      [measure(result.widthMM), t('preview.wide')],
      [measure(result.heightMM), t('preview.high')],
      [compactFamily ? depthText() : measure(depth), compactFamily ? t('preview.thick') : t('preview.deep')]
    ];
    sizeText.replaceChildren(...dimensions.map(([value, label]) => {
      const item = document.createElement('span'), number = document.createElement('strong'), caption = document.createElement('small');
      number.textContent = value; caption.textContent = label;
      item.append(number, caption); return item;
    }));
    query('[data-preview-depth-text]').textContent=`${depthText()} ${t('preview.thick')}`;
    const sticky=document.querySelector('[data-sb-size]');
    if(sticky)sticky.textContent=input?.value.trim()?'≈ '+text:'';
    document.querySelectorAll('[data-spec-size]').forEach(node=>node.textContent=' ≈ '+measure(result.widthMM));
    document.querySelectorAll('[data-union-spec-height]').forEach(node=>node.textContent=t('preview.follows_name',{size:measure(result.heightMM)}));
  }

  function clearDimensions() {
    const sticky=document.querySelector('[data-sb-size]');
    if(sticky)sticky.textContent='';
    document.querySelectorAll('[data-spec-size]').forEach(node=>node.textContent='');
    document.querySelectorAll('[data-union-spec-height]').forEach(node=>node.textContent=t('preview.varies_with_name'));
  }

  function changed(options) {
    revision++;
    if(lightningProperty){lightningProperty.disabled=true;lightningProperty.value='';}
    if(signSpec){
      signSpec.disabled=true;signSpec.value='';
      signReview.disabled=!(input?.value||'').trim();
      signReview.value='Check sign dimensions and letter connections before production; current preview is not confirmed.';
    }
    if(keychainSpec){
      keychainSpec.disabled=true;keychainSpec.value='';
      keychainReview.disabled=!(input?.value||'').trim();
      keychainReview.value=cfg.magnet?'Check magnet dimensions and letter connections before production; current preview is not confirmed.':'Check keychain dimensions and ring attachment before production; current preview is not confirmed.';
    }
    if(supportToggle){if(!options?.preserveSupport)supportToggle.checked=false;supportToggle.disabled=true;supportCard.hidden=true;}
    highlightUntil=0;if(!options?.preserveSupport){supportData=null;supportChoice=null;}supportProperties();
    if(accentNote)accentNote.hidden=true;
    clearTimeout(timer);
    const raw=(input?.value||'').trim();
    cancelAnimationFrame(drawFrame);
    editDeadline=performance.now()+(phoneRendering?500:300);
    if(!raw){
      input?.setCustomValidity('');
      wanted=false;result=null;root.dataset.state='empty';gallery.hidden=true;size.hidden=true;
      fallback.hidden=false;retry.hidden=true;gallery.removeAttribute('aria-busy');clearDimensions();
      query('[data-preview-fallback-message]').textContent=t('preview.type_name');
      status.textContent='';return;
    }
    const letters=model ? model.shapeName(raw,cfg.maxLength,manifest?.shaping,manifest?.terminal_map,cfg.accentedLetters?manifest:null)!==null : /^[A-Za-z]*$/.test(raw);
    // A family may need more than one letter (minletters: Hunter x Hunter, 3).
    const minLength=cfg.minLength||1,valid=letters&&(!raw||raw.length>=minLength);
    const why=letters?t('preview.min_letters',{count:minLength}):cfg.accentedLetters?t('preview.letters_accents'):t('preview.az_only');
    // Save the customer's choice immediately, including during a render or retry.
    // The select itself is also a form control, so its choice survives load errors.
    if(lightningProperty&&valid&&raw&&model){
      lightningOptions(raw);
      lightningProperty.disabled=false;lightningProperty.value=model.lightningLayout(raw,lightningChoice).layout;
    }
    input?.setCustomValidity(valid?'':letters||cfg.accentedLetters?why:t('preview.az_validity',{object:t('object.'+objectLabel)}));
    if(!valid){
      root.dataset.state='invalid';size.hidden=true;
      gallery.removeAttribute('aria-busy');
      if(!result)query('[data-preview-fallback-message]').textContent=why;
      clearDimensions();
      status.textContent=why;
      return;
    }
    if(root.dataset.state==='invalid')root.dataset.state=result?'ready':'loading';
    wanted=true;
    if(worker||loading)pending();
    if(worker)timer=setTimeout(build,phoneRendering?500:300);
  }

  function pending() {
    root.dataset.state=result?'updating':'loading';
    gallery.setAttribute('aria-busy','true');
    size.hidden=true;clearDimensions();
    if(result)status.textContent=t('preview.updating');
    else {
      gallery.hidden=true;fallback.hidden=false;retry.hidden=true;
      query('[data-preview-fallback-message]').textContent=t('preview.loading');
      status.textContent='';
    }
  }

  async function build() {
    if(!worker||busy||!wanted||destroyed||root.dataset.state==='invalid')return;
    const remaining=editDeadline-performance.now();
    if(remaining>0){clearTimeout(timer);timer=setTimeout(build,remaining);return;}
    wanted=false;
    const raw=(input?.value||'').trim();
    // Before a name is typed the preview shows the storefront language's
    // placeholder word (Name, Nome, Nom, Nombre), never a sample name.
    const example=String(cfg.exampleName||'Name').replace(/[^A-Za-z]/g,'').slice(0,cfg.maxLength)||'Name';
    const text=raw||example;
    lightningOptions(text);
    let prepared;const jobRevision=revision,run=generation;busy=true;
    try {prepared=await preparer.prepare(text,{id:jobRevision,lightningChoice,supportSelected:raw?supportChoice:false});}
    catch(error){if(run===generation&&!destroyed){busy=false;fail(error);}return;}
    if(run!==generation||destroyed)return;
    if(jobRevision!==revision){busy=false;build();return;}
    const {bounds,lightning,displayText,plaqueKeychain}=prepared;
    currentJob={id:revision,bounds,text,displayText,lightning,plaqueKeychain,example:!raw};busy=true;
    pending();
    workerTimer=setTimeout(()=>{
      if(run===generation&&!destroyed&&currentJob?.id===jobRevision)fail(new Error('Preview worker timed out'));
    },15000);
    worker.postMessage(prepared.message,prepared.transfer);
  }

  function completeSmallProduct(data,job){
    lightningProperties(job);
    if(data.error){
      result=null;root.dataset.state='error';gallery.hidden=true;size.hidden=true;fallback.hidden=false;retry.hidden=true;
      gallery.removeAttribute('aria-busy');clearDimensions();
      query('[data-preview-fallback-message]').textContent=cfg.magnet?t('preview.magnet_error'):cfg.ornament?t('preview.ornament_error'):t('preview.keychain_error');
      status.textContent=t('preview.construction_check');
      if(!job.example){keychainReview.disabled=false;keychainReview.value=data.error||data.review;}
      return;
    }
    const o=data.outline,p=data.ppm;
    const loopCaption=query('[data-keychain-caption]');
    if(loopCaption)loopCaption.textContent=data.ringReview?t('preview.ring_caption'):cfg.ornament?t('preview.ornament_caption'):!!cfg.keychain?t('preview.keychain_caption'):t('preview.plaque_caption');
    // Crop transparent worker margins exactly as in the approved local study.
    const left=Math.max(0,Math.floor((o.minX-4)*p)),top=Math.max(0,Math.floor(data.height-(o.maxY+4)*p));
    const width=Math.min(data.width-left,Math.ceil((o.maxX-o.minX+8)*p));
    const height=Math.min(data.height-top,Math.ceil((o.maxY-o.minY+8)*p));
    const bounds={minX:left/p,minY:(data.height-top-height)/p,width:width/p,height:height/p};
    const fields={};
    for(const key of ['baseField','faceField',...(data.midField?['midField']:[]),...(data.redMidField?['redMidField']:[])]){
      const out=fields[key]=new Float32Array(width*height);
      for(let y=0;y<height;y++)out.set(data[key].subarray((top+y)*data.width+left,(top+y)*data.width+left+width),y*width);
    }
    result={outline:o,widthMM:o.maxX-o.minX,heightMM:o.maxY-o.minY};
    try{show({...data,...fields,width,height,bottomMM:0},bounds);}catch(error){fail(error);return;}
    keychainReview.disabled=job.example||!data.review;keychainReview.value=data.review||'';
    keychainSpec.disabled=job.example;
    keychainSpec.value=JSON.stringify({revision:cfg.magnet?(cfg.allowStrengthSizeException?'magnet-solid-strength-v1':'magnet-solid-v1'):(cfg.ornament?'ornament-top-v1':cfg.allowContourLoop?'keychain-contour-candidate-v1':'keychain-loop-v2'),family:compactFamily,name:job.text,
      sizingException:data.sizingException||undefined,
      lightning:job.lightning,connections:data.connections,fontScale:data.scale,
      widthMM:+result.widthMM.toFixed(2),heightMM:+result.heightMM.toFixed(2),layersMM:layers,
      magnetConstruction:cfg.magnet?data.magnetConstruction:undefined,
      magnetBorder:cfg.magnet?data.magnetBorder:undefined,
      magnetScale:cfg.magnet?data.magnetScale:undefined,
      magnetStep:cfg.magnet?data.magnetStep:undefined,
      keychainBorder:cfg.keychain?data.keychainBorder:undefined,
      loop:cfg.magnet?undefined:!data.ring?null:{placement:data.ring.placement,centerOffsetMM:data.ring.centerOffsetMM,
        ...(data.ring.edgeProfile?{shape:data.ring.shape,edgeProfileMM:data.ring.edgeProfile,anchorRule:data.ring.anchorRule}:{}),
        ...(data.ring.placement==='top-balance'?{balanceXFromLeftMM:+(data.ring.balanceXMM-o.minX).toFixed(2),neckMM:data.ring.stem?data.ring.stem.depthMM:0}:{}),
        xFromLeftMM:+(data.ring.x-o.minX).toFixed(2),yFromBottomMM:+(data.ring.y-o.minY).toFixed(2),
        openingWidthMM:data.ring.openingWidthMM,openingDepthMM:data.ring.openingDepthMM,outerDiameterMM:data.ring.outerDiameterMM}});
    gallery.hidden=false;fallback.hidden=true;size.hidden=false;root.dataset.state='ready';root.dataset.connectionReview=String(!!data.review);root.dataset.ringDiagnostics=JSON.stringify(data.ringDiagnostics||{});gallery.removeAttribute('aria-busy');
    views.forEach(view=>{const vn=view.dataset.previewView==='upright'?(metalSurface?t('view.fridge'):t('view.angled')):view.dataset.previewView==='top'?(metalSurface||cfg.ornament?t('view.front'):t('view.top')):t('view.thickness');view.querySelector('canvas').setAttribute('aria-label',t('view.aria_label',{view:vn,text:job.text,object:t('object.'+objectLabel)})+(data.ring?t('view.with_loop'):''));});
    status.textContent=data.ringReview?t('preview.ring_review'):data.review?t('preview.review_needed'):job.example?t('preview.example',{object:t('object.'+objectLabel)}):(flat?t('preview.flat_view',{name:job.text}):t('preview.all_views',{name:job.text}));
    recoveryAttempts=0;
    dimensions();draw();cardReady(job);
  }

  function complete({data}) {
    clearTimeout(workerTimer);busy=false;
    if(data.id!==revision){build();return;}
    // A plaque magnet renders through the sign worker (the composite plaque).
    if(compactFamily&&!cfg.magnetPlaque&&!cfg.keychainPlaque){completeSmallProduct(data,currentJob);return;}
    if(data.error){fail(new Error(data.error));return;}
    const job=currentJob;
    let scale=data.physicalScale||model.physicalScale(data.outline,cfg.sizing),plaque=null;
    if(cfg.magnetPlaque){
      // 100 mm plaque, enlarged only until the magnet pocket fits (model.plaqueMagnet).
      plaque=model.plaqueMagnet(data,cfg.sizing,cfg.plaqueMinScale);
      scale=plaque.error?model.physicalScale(data.nominalOutline,cfg.sizing):plaque.scale;
      if(plaque.error)data.review=plaque.error;
    }
    // A plaque keychain's size and D loop were fixed by the model (<= 100 mm).
    const plaqueLoop=cfg.keychainPlaque?job.plaqueKeychain:null;
    if(plaqueLoop){
      if(plaqueLoop.error){data.review=plaqueLoop.error;scale=model.physicalScale(data.nominalOutline,cfg.sizing);}
      else{scale=plaqueLoop.scale;if(cfg.ornament)data.productKind='ornament';data.ring={x:plaqueLoop.centre[0]*scale,y:plaqueLoop.centre[1]*scale,nx:plaqueLoop.normal[0],ny:-plaqueLoop.normal[1],openingDepthMM:plaqueLoop.loop.innerR,openingWidthMM:2*plaqueLoop.loop.innerR,outerDiameterMM:2*plaqueLoop.loop.outerR};}
    }
    root.dataset.workerMs=String(Math.round(data.workerMs));
    const bounds={minX:(job.bounds.minX+(data.offsetX||0))*scale,minY:(job.bounds.minY+(data.offsetY||0))*scale,width:data.width/data.ppm*scale,height:data.height/data.ppm*scale};
    for(const field of [data.baseField,data.faceField,data.midField,data.redMidField,data.capField,...(data.accents||[]).map(a=>a.field)].filter(Boolean))for(let i=0;i<field.length;i++)field[i]*=scale;
    data.bottomMM*=scale;
    const outline={minX:bounds.minX+data.outline.minX*scale,maxX:bounds.minX+data.outline.maxX*scale,minY:bounds.minY+data.outline.minY*scale,maxY:bounds.minY+data.outline.maxY*scale};
    result={outline,widthMM:outline.maxX-outline.minX,heightMM:outline.maxY-outline.minY};
    if(plaque||plaqueLoop){
      result.widthMM=(data.nominalOutline.maxX-data.nominalOutline.minX)*scale;
      result.heightMM=(data.nominalOutline.maxY-data.nominalOutline.minY)*scale;
    }
    const analysis=data.support;
    if(analysis){
      result.widthMM=(data.nominalOutline.maxX-data.nominalOutline.minX)*scale;
      result.heightMM=(data.nominalOutline.maxY-data.nominalOutline.minY)*scale;
      supportData=analysis;
      root.dataset.leanAngle=analysis.angle.toFixed(2);
      const foot=analysis.foot,second=analysis.secondFoot;
      if(foot){
        const where=footPlace(analysis,job.displayText);
        supportData.placement=t('foot.under',{where});
        const placed=f=>({letterIndex:f.glyphIndex+1,letter:f.letter,
          xFromLeftMM:+(f.centreX-data.nominalOutline.minX*scale).toFixed(2),
          exposedHeightMM:+f.visibleHeightMM.toFixed(2),topAboveGroundMM:+(f.bounds[3]-f.bounds[1]).toFixed(2)});
        // A sign balanced on one point gets a second foot on the other side of its mass.
        const first=placed(foot);
        supportData.spec={revision:second?'geometry-feet-v2':'geometry-foot-v1',family:cfg.support.family,name:job.text,lightning:job.lightning,
          letterIndex:first.letterIndex,letter:first.letter,side:analysis.side,
          xFromLeftMM:first.xFromLeftMM,exposedHeightMM:first.exposedHeightMM,topAboveGroundMM:first.topAboveGroundMM,
          ...(second?{second:placed(second)}:{}),
          soleMM:10,neckMM:8,depthMM:layers[0],overlapMM:3,chamferMM:.7,widthMM:+result.widthMM.toFixed(2),heightMM:+result.heightMM.toFixed(2)};
        query('[data-support-label]').textContent=analysis.recommended?t('support.recommended_label'):t('support.add_label');
        query('[data-support-badge]').textContent=analysis.recommended?t('support.recommended_badge'):t('support.optional_badge');
        query('[data-support-help]').textContent=analysis.recommended?
          (analysis.selected?t('support.help_selected'):t('support.help_recommended',{where})):
          (Math.abs(analysis.angle)>5?t('support.may_lean_strong',{where}):t('support.may_lean_mild',{where}));
        query('[data-support-explanation]').textContent=t('support.explanation');
        if(analysis.selected)result.feet=[foot,second].filter(Boolean).map(f=>({...f,bounds:f.bounds.map((v,i)=>v+(i%2?job.bounds.minY:job.bounds.minX)*scale)}));
      } else if(analysis.needsReview){
        query('[data-support-help]').textContent=t('support.manual_check');
        query('[data-support-explanation]').textContent=t('support.no_room');
      }
      supportCard.hidden=analysis.supportDisabled||job.example||(!analysis.eligible&&!analysis.needsReview);
      query('.ilup__support-toggle').hidden=!analysis.eligible;
      supportToggle.disabled=job.example||!analysis.eligible;
      supportToggle.checked=analysis.selected&&!job.example;
      if(analysis.selected&&supportChoice===null&&!job.example){
        highlightUntil=performance.now()+3500;clearTimeout(highlightTimer);highlightTimer=setTimeout(draw,3600);
      }
      if(job.example)supportData=null;
      supportProperties();
    }
    try{show(data,bounds);}catch(error){fail(error);return;}
    gallery.hidden=false;fallback.hidden=true;size.hidden=false;root.dataset.state='ready';root.dataset.connectionReview=String(!!data.review);root.dataset.ringDiagnostics=JSON.stringify(data.ringDiagnostics||{});gallery.removeAttribute('aria-busy');
    lightningProperties(job);
    const supported=analysis?.selected,where=supported?footPlace(analysis,job.displayText):'';
    views.forEach(view=>{const vn=view.dataset.previewView==='upright'?(plaque?t('view.fridge'):plaqueLoop?t('view.angled'):t('view.standing')):view.dataset.previewView==='top'?(plaque||cfg.ornament?t('view.front'):t('view.top')):t('view.thickness');const suffix=(plaqueLoop?t('view.with_loop'):'')+(supported?t('view.with_foot',{where}):analysis&&Math.abs(analysis.angle)>.15?t('view.angle_estimated'):'');view.querySelector('canvas').setAttribute('aria-label',t('view.aria_label',{view:vn,text:job.text,object:t('object.'+objectLabel)})+suffix);});
    if(signSpec){
      signSpec.disabled=job.example;signReview.disabled=job.example||!data.review;signReview.value=data.review||'';
      signSpec.value=JSON.stringify({revision:'sign-connections-v1',family:cfg.support.family,name:job.text,
        lightning:job.lightning,fontScale:scale,connections:data.connections,widthMM:+result.widthMM.toFixed(2),heightMM:+result.heightMM.toFixed(2),layersMM:layers});
    }
    if(plaque){
      keychainReview.disabled=job.example||!data.review;keychainReview.value=data.review||'';
      keychainSpec.disabled=job.example||!!plaque.error;
      keychainSpec.value=plaque.error?'':JSON.stringify({revision:'magnet-plaque-v1',family:compactFamily,name:job.text,
        fontScale:scale,widthMM:+result.widthMM.toFixed(2),heightMM:+result.heightMM.toFixed(2),layersMM:layers,
        magnetConstruction:plaque.construction,magnetScale:plaque.k,magnetStep:plaque.step});
    }
    if(plaqueLoop){
      keychainReview.disabled=job.example||!data.review;keychainReview.value=data.review||'';
      keychainSpec.disabled=job.example||!!plaqueLoop.error;
      const left=job.bounds.minX+data.nominalOutline.minX,bottom=job.bounds.minY+data.nominalOutline.minY;
      keychainSpec.value=plaqueLoop.error?'':JSON.stringify({revision:cfg.ornament?'ornament-plaque-v1':'keychain-plaque-v1',family:compactFamily,name:job.text,
        fontScale:scale,widthMM:+result.widthMM.toFixed(2),heightMM:+result.heightMM.toFixed(2),layersMM:layers,keychainConstruction:'plaque-v1',
        loop:{placement:cfg.ornament?'plaque-top':'plaque-d',...(cfg.ornament?{balanceXFromLeftMM:+((plaqueLoop.balanceX-left)*scale).toFixed(2),neckMM:+((plaqueLoop.stem||0)*scale).toFixed(2)}:{}),xFromLeftMM:+((plaqueLoop.centre[0]-left)*scale).toFixed(2),yFromBottomMM:+((plaqueLoop.centre[1]-bottom)*scale).toFixed(2),
          angleDeg:plaqueLoop.angle,rootsMM:plaqueLoop.legs.map(l=>+(l.len*scale).toFixed(2)),
          openingWidthMM:2*plaqueLoop.loop.innerR,openingDepthMM:plaqueLoop.loop.innerR,outerDiameterMM:2*plaqueLoop.loop.outerR}});
    }
    status.textContent=data.review?t('preview.review_needed'):analysis?.needsReview?t('preview.cant_stand'):job.example?t('preview.example',{object:t('object.'+objectLabel)}):analysis?.supportDisabled?t('preview.no_support'):supported?t('preview.foot_added',{where}):analysis?.eligible?t('preview.no_foot'):(flat?t('preview.flat_view',{name:job.text}):t('preview.all_views',{name:job.text}));
    // Accents the design cannot carry (a spiked end letter, two accents
    // that would touch) are named, not hidden.
    if(accentNote&&cfg.accentedLetters&&!job.example){
      const shaped=model.shapeName(job.text,cfg.maxLength,manifest.shaping,manifest.terminal_map,manifest)||'';
      const dropped=model.droppedAccents(job.text,shaped,manifest),last=[...shaped].length-1;
      const ends=manifest.shaping==='terminals'&&dropped.some(i=>i===0||i===last);
      accentNote.textContent=[ends?t('preview.accents_left_off'):'',dropped.some(i=>!ends||(i>0&&i<last))?t('preview.accents_touching'):''].filter(Boolean).join(' ');
      accentNote.hidden=!dropped.length;
    }
    recoveryAttempts=0;
    dimensions();draw();cardReady(job);
  }

  function stopRuntime() {
    clearTimeout(recoveryTimer);
    preparer?.dispose();preparer=null;
    clearTimeout(workerTimer);worker?.terminate();worker=null;busy=false;loading=false;
    loadController?.abort();
    if(renderer){renderer.canvas.removeEventListener('webglcontextlost',rendererLost);renderer.dispose();renderer.gl.getExtension('WEBGL_lose_context')?.loseContext();}
    renderer=null;viewTargets=[];result=null;graphics=null;graphicsReady=false;geometry=null;
    root.removeAttribute('data-room-ready');
    root.removeAttribute('data-room-visible');
  }
  function keychainCamera(bounds,w,h,elevation,upright,annotated){
    // Keep the old straight-on (90°) camera for Front. To see the thickness and
    // both cord strands, move around the vertical hanging axis rather than underneath it.
    const hangingDetail=cfg.ornament && annotated;
    if(metalSurface||hangingDetail){
      const front=elevation>1.5,detail=elevation<.7;
      const yaw=(hangingDetail?52:front?0:detail?48:25)*Math.PI/180,pitch=(front?0:6)*Math.PI/180;
      const sy=Math.sin(yaw),cy=Math.cos(yaw),sp=Math.sin(pitch),cp=Math.cos(pitch);
      const right=[cy,0,sy],up=[-sy*sp,cp,cy*sp],direction=[sy*cp,sp,-cy*cp];
      const margin=front||detail?8:16;
      // Controls and captions sit outside the canvas, so use its full height.
      const between=Math.max(1,h);
      let span=Math.max(bounds.width*cy+depth*sy+margin,(bounds.height*cp+bounds.width*sy*sp+depth*cy*sp+(hangingDetail?4:10))*w/between);
      if(annotated)span*=Math.max(w/Math.max(1,w-(hangingDetail?32:70)),between/Math.max(1,between-(hangingDetail?36:60)));
      return {right,up,direction,span,project:p=>{
        const d=[p[0]-bounds.minX-bounds.width/2,p[1]-bounds.minY-bounds.height/2,p[2]-depth/2];
        const dot=a=>a.reduce((n,v,i)=>n+v*d[i],0);
        return {x:w/2+dot(right)*w/span,y:h/2-dot(up)*w/span};
      }};
    }
    const s=Math.sin(elevation),c=Math.cos(elevation),aspect=w/h;
    let span=Math.max(bounds.width+4,(bounds.height*s+depth*c+4)*aspect);
    if(annotated)span*=Math.max(w/Math.max(1,w-70),h/Math.max(1,h-60));
    return {right:[1,0,0],up:[0,s,c],direction:[0,c,-s],span,
      project:p=>({x:w/2+(p[0]-bounds.minX-bounds.width/2)*w/span,
        y:h/2-((p[1]-bounds.minY-bounds.height/2)*s+(p[2]-depth/2)*c)*w/span})};
  }
  function fail(error) {
    if(destroyed)return;
    if(!input?.value.trim()){
      generation++;stopRuntime();changed();return;
    }
    // A temporary load/worker failure gets one fresh runtime. Keep the current
    // input and choices, invalidate the old order spec, and never retry forever.
    const transient=error.name==='AbortError'||/timed out|Preview asset unavailable|Preview image unavailable|Preview worker failed|Graphics context lost|Failed to fetch|NetworkError/i.test(error.message);
    if(transient&&recoveryAttempts<1){
      recoveryAttempts++;generation++;stopRuntime();changed({preserveSupport:true});
      if(!['empty','invalid'].includes(root.dataset.state))pending();
      recoveryTimer=setTimeout(start,250);
      console.warn('Preview recovering:',error.message);
      return;
    }
    generation++;stopRuntime();root.dataset.state='error';gallery.hidden=true;size.hidden=true;fallback.hidden=false;retry.hidden=false;
    gallery.removeAttribute('aria-busy');
    clearDimensions();
    if(signSpec){signSpec.disabled=true;signSpec.value='';signReview.disabled=!(input?.value||'').trim();signReview.value='Sign preview unavailable; check dimensions and letter connections before production.';}
    if(supportToggle)supportToggle.disabled=true;
    query('[data-preview-fallback-message]').textContent=t('preview.error');
    status.textContent=t('preview.retry_prompt');
    console.warn('Preview unavailable:',error.message);
  }
  async function start() {
    if(loading||destroyed)return;
    stopRuntime();loading=true;const run=++generation;
    if(input?.value.trim())pending();
    loadController=new AbortController();
    const timeout=setTimeout(()=>loadController?.abort(),15000);
    const fetchAsset=async(url,json=false)=>{const response=await fetch(url,{signal:loadController.signal});if(!response.ok)throw Error('Preview asset unavailable');return json?response.json():response.text();};
    const image=url=>new Promise((resolve,reject)=>{const im=new Image();im.crossOrigin='anonymous';im.onload=()=>resolve(im);im.onerror=()=>reject(Error('Preview image unavailable'));loadController.signal.addEventListener('abort',()=>reject(Error('Preview image timed out')),{once:true});im.src=url;});
    const aborted=new Promise((_,reject)=>loadController.signal.addEventListener('abort',()=>reject(Error('Preview assets timed out')),{once:true}));aborted.catch(()=>{});
    // The page starts the lettering downloads early (snippets/union-preview.liquid);
    // take each over once, and load it again if that request failed.
    const early=(url,load)=>{const request=window.ILPreviewEarly?.[url];if(!request)return load();delete window.ILPreviewEarly[url];return Promise.race([request.catch(load),aborted]);};
    // Masks come as Blobs (the image Accept header keeps the CDN's WebP copy) and
    // decode to bitmaps off the main thread; the preparer takes them over.
    const mask=url=>early(url,()=>fetch(url,{signal:loadController.signal,headers:{accept:'image/webp,image/png,image/*;q=0.8'}}).then(response=>{if(!response.ok)throw Error('Preview image unavailable');return response.blob();}).then(blob=>createImageBitmap(blob)));
    try {
      // Start compiling this product type's graphics as soon as the renderer code
      // arrives, while the lettering still downloads; the views later link the
      // browser's cached copy. Only where it compiles in the background. The page
      // usually started it already (snippets/union-preview.liquid, the same
      // program options as the views below).
      if(!window.ILPreviewEarly?.compiling)import(cfg.renderer).then(({Renderer})=>{
        if(run!==generation||destroyed)return;
        const early=new Renderer(document.createElement('canvas'),0,false,{hardware:!!cfg.keychain,signSurface:!compactFamily});
        const release=()=>{early.dispose();early.gl.getExtension('WEBGL_lose_context')?.loseContext();};
        if(!early.parallel){release();return;}
        early.ready().catch(()=>{}).finally(release);
      }).catch(()=>{});
      const room=!compactFamily&&cfg.roomScene?Promise.all([fetchAsset(cfg.roomScene,true),image(cfg.roomImage),image(cfg.roomMask)]).then(([scene,image,mask])=>{
        const vector=v=>Array.isArray(v)&&v.length===3&&v.every(Number.isFinite);
        const valid=scene.emptyScene&&scene.projection==='orthographic'&&['right','up','direction','targetMM','light'].every(k=>vector(scene[k]))&&['widthMM','heightMM','minimumWidthMM','minimumHeightMM','lightDistanceMM','lightRadiusMM'].every(k=>Number.isFinite(scene[k])&&scene[k]>0);
        return valid?{scene,image,mask}:null;
      }).catch(()=>null):Promise.resolve(null);
      const values=await Promise.all([import(cfg.model),import(cfg.renderer),early(cfg.manifest,()=>fetchAsset(cfg.manifest,true)),Promise.all(cfg.masks.map(mask)),fetchAsset(cfg.worker),cfg.support?fetchAsset(cfg.support.engine):Promise.resolve(''),cfg.connections?fetchAsset(cfg.connections):Promise.resolve(''),cfg.steelTexture?image(cfg.steelTexture):Promise.resolve(null),cfg.polygonClipping?fetchAsset(cfg.polygonClipping):Promise.resolve(''),cfg.clipper?fetchAsset(cfg.clipper):Promise.resolve(''),room]);
      if(run!==generation||destroyed)return;
      [model,{Renderer},manifest,images]=values;
      const nextPreparer=await model.createPreparer(manifest,images,cfg,{transferImages:true});
      if(run!==generation||destroyed){nextPreparer.dispose();return;}
      preparer=nextPreparer;
      // CDN-hosted Worker URLs cannot be used directly across origins. Fetching
      // the script and creating a local Blob worker supports Shopify asset URLs.
      // polygon-clipping is an ES module; strip the export statement so it runs
      // in a classic worker context and exposes self.polygonClipping via its UMD.
      const pcScript=values[8]?values[8].replace(/\bexport\s*\{[^}]*\}\s*;?\s*$/,'self.polygonClipping=Zt;\n'):'';
      const clScript=values[9]?values[9].replace(/\bexport\s*\{[^}]*\}\s*;?\s*$/,'')+'\nself.ClipperLib=M.exports;\n':'';
      const url=URL.createObjectURL(new Blob([pcScript,clScript,values[5],'\n',values[6],'\n',values[4]],{type:'text/javascript'}));
      try{worker=new Worker(url);}finally{URL.revokeObjectURL(url);}
      // The name's geometry can arrive while the graphics still compile: hold it.
      worker.onmessage=event=>{
        if(run!==generation||destroyed)return;
        if(graphicsReady){complete(event);return;}
        clearTimeout(workerTimer);
        graphics?.then(()=>{if(run===generation&&!destroyed)complete(event);},()=>{});
      };
      worker.onerror=event=>{if(run===generation&&!destroyed)fail(new Error(event.message||'Preview worker failed'));};
      // A browser without WebGL 2 draws the design flat (il-flat-picture.js; owner, 22 October
      // 2026): the same geometry, so the same print shape, in one front view.
      try{
        renderer=new Renderer(document.createElement('canvas'),0,false,{pixelRatio:fullQuality?Math.max(2,devicePixelRatio||1):undefined,mobileBudget:phoneRendering&&!fullQuality,cameraFrame:compactFamily?keychainCamera:model.cameraFrame,layers,midColour:cfg.colours.mid,midAccentColour:cfg.colours.midAccent,capColour:cfg.colours.cap,deskSurface:!cfg.magnet,signSurface:!compactFamily,roomSurface:!!values[10],roomScene:values[10]?.scene,roomImage:values[10]?.image,roomMask:values[10]?.mask,metalSurface,steelTexture:values[7],hardware:!!cfg.keychain});
      }catch(error){
        if(!cfg.flat||!/WebGL/i.test(error.message))throw error;
        renderer=null;flat=await import(cfg.flat);
        if(run!==generation||destroyed)return;
        showFlat();
      }
      root.toggleAttribute('data-room-ready',!!renderer&&!!values[10]);
      rendererLost=event=>{event.preventDefault();fail(new Error('Graphics context lost'));};
      renderer?.canvas.addEventListener('webglcontextlost',rendererLost);
      viewTargets=views.map(view=>{
        const previous=view.querySelector('canvas'),canvas=previous.cloneNode();previous.replaceWith(canvas);
        const mode=view.dataset.previewView;
        const elevation=compactFamily?(mode==='upright'?(metalSurface?78:60):mode==='top'?90:24):(mode==='upright'?8:mode==='top'?65:24);
        return {view,canvas,context:canvas.getContext('2d'),elevation,upright:!compactFamily&&mode==='upright',clear:!!cfg.ornament};
      });
      // A first visit can spend seconds compiling the graphics: they compile in the
      // background while the name is prepared, and the static image shows meanwhile.
      graphics=renderer?renderer.ready():Promise.resolve();
      graphics.then(()=>{if(run===generation)graphicsReady=true;},error=>{if(run===generation)fail(error);});
      loading=false;wanted=true;changed({preserveSupport:true});clearTimeout(timer);build();
    }catch(error){if(run===generation)fail(error);}finally{clearTimeout(timeout);}
  }

  input?.addEventListener('focus',()=>{if(!worker&&!loading&&!destroyed)start();});
  input?.addEventListener('input',event=>{
    changed(event);
    if(input.value.trim()&&!worker&&!loading&&!destroyed&&root.dataset.state!=='invalid')start();
  });
  lightningSelect?.addEventListener('change',()=>{lightningChoice=lightningSelect.value;lightningShown();changed();});
  supportToggle?.addEventListener('change',()=>{
    supportChoice=supportToggle.checked;
    supportProperties();revision++;wanted=true;
    highlightUntil=supportToggle.checked?performance.now()+3500:0;
    clearTimeout(highlightTimer);highlightTimer=setTimeout(draw,3600);
    build();
  });
  // Variant handlers update aria-pressed in the same click; render next frame.
  form?.addEventListener('click',event=>{if(event.target.closest('[data-opt-position]'))draw();});
  views.forEach(view=>view.addEventListener('click',()=>{
    active=view.dataset.previewView;root.dataset.active=active;
    views.forEach(card=>{const selected=card===view;card.classList.toggle('is-active',selected);card.setAttribute('aria-pressed',String(selected));});
    draw();
  }));
  productScope.querySelectorAll('[data-preview-units]').forEach(button=>button.addEventListener('click',()=>{
    units=button.dataset.previewUnits;
    productScope.querySelectorAll('[data-preview-units]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    dimensions();draw();
  }));
  retry.addEventListener('click',()=>{recoveryAttempts=0;start();});
  const observer=new ResizeObserver(draw);observer.observe(gallery);
  const unload=event=>{
    if(!event.target.contains(root))return;
    destroyed=true;generation++;stopRuntime();observer.disconnect();cancelAnimationFrame(drawFrame);clearTimeout(timer);clearTimeout(highlightTimer);
    document.removeEventListener('shopify:section:unload',unload);
  };
  document.addEventListener('shopify:section:unload',unload);
  if(input?.value.trim())start();
  else changed();
}
